// Versioned, allowlisted return contract for the existing Google callback.
const TARGETS = Object.freeze({
  production: "https://timely365.com",
  preview: "https://timely-client-production-448572491019.us-central1.run.app",
  development: "https://timely-client-development-448572491019.us-central1.run.app",
  local: "http://localhost:3001",
  localPreview: "http://localhost:3003",
});
const STORAGE_KEY = "timelyCalendarOAuthState";
function beginCalendarOAuth(origin, storage, crypto, now = Date.now(), context = {}) {
  const target = Object.keys(TARGETS).find(key => TARGETS[key] === origin);
  if (!target) throw new Error("Open Timely365 at its main address to connect Google Calendar.");
  const nonce = Array.from(crypto.getRandomValues(new Uint8Array(24)), value => value.toString(16).padStart(2, "0")).join("");
  const state = `timely-calendar-v1:${target}:${nonce}`;
  storage.setItem(STORAGE_KEY, JSON.stringify({ state, createdAt: now, returnPath: safeCalendarPath(context.returnPath), popup: Boolean(context.popup) }));
  return state;
}
function safeCalendarPath(path) {
  if (typeof path !== 'string' || !/^\/(biz\/calendar|myschedule)([?#]|$)/.test(path) || path.includes('\\')) return '/biz/calendar?v=booking';
  return path;
}
function calendarOAuthContext(state, storage) {
  try {
    const saved = JSON.parse(storage.getItem(STORAGE_KEY) || 'null');
    return saved?.state === state ? { returnPath: safeCalendarPath(saved.returnPath), popup: Boolean(saved.popup) } : null;
  } catch (_) { return null; }
}
function consumeCalendarOAuth(state, storage, now = Date.now()) {
  let saved;
  try { saved = JSON.parse(storage.getItem(STORAGE_KEY) || "null"); } catch (_) { return false; }
  if (!saved || !state || saved.state !== state || now - saved.createdAt > 600000 || now < saved.createdAt) return false;
  storage.removeItem(STORAGE_KEY);
  return true;
}
function buildCalendarReturnUrl(query) {
  if (typeof query.state !== "string") return null;
  const match = /^timely-calendar-v1:([A-Za-z]+):([a-f0-9]{48})$/.exec(query.state);
  if (!match || !Object.prototype.hasOwnProperty.call(TARGETS, match[1])) return null;
  if (typeof query.code !== "string" && typeof query.error !== "string") return null;
  const url = new URL("/connect/google_calendar", TARGETS[match[1]]);
  for (const key of ["code", "state", "error", "error_description"]) {
    if (typeof query[key] === "string") url.searchParams.set(key, query[key]);
  }
  return url.toString();
}
module.exports = { beginCalendarOAuth, consumeCalendarOAuth, buildCalendarReturnUrl, calendarOAuthContext };
